import React, { type RefObject, useRef } from "react";
import * as CompareItemStyles from "../styles/CompareItem";
import * as SelectPane from "../../../../../common-deprecated/styles/v2/lexus/custom/SelectPane";
import { useCloseOnOutsideClick } from "../../../../../common-deprecated/hooks";
import { useCompareV2Selector } from "../../../redux/store";
import ModelPanel from "./ModelPanel";
import SubmodelPanel from "./SubmodelPanel";
import GradePanel from "./GradePanel";
import { CompareV2Label } from "../../../utils/labels";
import { getEngineName } from "../../../utils/formatters/nameFormatters";
import ButtonPrimary from "../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import ButtonSecondary from "../../../../../common-deprecated/components/aem/lexus/button/ButtonSecondary";
import useSelectGrade from "../../../hooks/useSelectGrade";
import { emptySelectedCarIds } from "../../../utils/constants";

export type SelectGradePropsType = {
    title: string;
    subtitle?: string;
    index: number;
    opened?: boolean;
    setOpenState: (open: boolean) => void;
    compareHeaderRef: RefObject<HTMLElement>;
};

const SelectGrade = (props: SelectGradePropsType): JSX.Element => {
    const { title, subtitle, index, opened, setOpenState, compareHeaderRef } = props;

    const selectedEngines = useCompareV2Selector((state) => state.newCarCompare.selectedEngines);

    const { selectedCar, setSelectedCar, makeSelection, closeFunction, compareHeaderHeight, viewPortHeight } =
        useSelectGrade(index, opened, setOpenState, compareHeaderRef);

    const paneRef = useRef<HTMLElement>(null);
    useCloseOnOutsideClick(paneRef, closeFunction);

    const panelLeftValue = selectedCar.model ? (selectedCar.submodelId ? 2 : 1) : 0;

    return (
        <>
            <>
                <CompareItemStyles.Title>
                    {title === "compareBodyTopSelectCar" ? <CompareV2Label label="compareBodyTopSelectCar" /> : title}
                </CompareItemStyles.Title>
                <CompareItemStyles.Subtitle>{subtitle}</CompareItemStyles.Subtitle>
                <CompareItemStyles.EngineNameTitle>
                    {getEngineName(selectedEngines[index])}
                </CompareItemStyles.EngineNameTitle>
            </>

            {opened && (
                <SelectPane.Wrapper
                    ref={paneRef}
                    top={compareHeaderHeight}
                    height={viewPortHeight && compareHeaderHeight ? viewPortHeight - compareHeaderHeight : null}
                >
                    <SelectPane.Body>
                        <SelectPane.Panels
                            currentPanel={panelLeftValue}
                            panelCount={3}
                            height={viewPortHeight}
                            compareHeaderHeight={compareHeaderHeight}
                        >
                            <ModelPanel setModel={(model) => setSelectedCar({ ...selectedCar, model, gradeId: "" })} />
                            <SubmodelPanel
                                setSelectedCar={setSelectedCar}
                                selectedCar={selectedCar}
                                clearSelection={() => setSelectedCar({ ...emptySelectedCarIds })}
                            />
                            <GradePanel
                                setSelectedCar={setSelectedCar}
                                selectedCar={selectedCar}
                                clearSelection={() => setSelectedCar({ ...selectedCar, submodelId: "", gradeId: "" })}
                            />
                        </SelectPane.Panels>
                    </SelectPane.Body>
                    <SelectPane.Footer>
                        <ButtonPrimary fullWidth disabled={!selectedCar.gradeId} onClick={makeSelection}>
                            <CompareV2Label label="compareSelectGradeConfirm" />
                        </ButtonPrimary>
                        <ButtonSecondary fullWidth onClick={closeFunction}>
                            <CompareV2Label label="compareSelectGradeCancel" />
                        </ButtonSecondary>
                    </SelectPane.Footer>
                </SelectPane.Wrapper>
            )}
        </>
    );
};

export default SelectGrade;
